import React from 'react'
import PropType from 'prop-types'

import { getMetaQuery } from 'utils/data'

import CopyOnly from './copy-only'
import Interactive from './interactive'

const RichCta = ({
  url,
  formUrl,
  variation,
  theme,
  utms,
  title,
  body,
  ctaText,
  form,
  nmls,
  metaParams,
  verticals,
  type,
}) => {
  const queryString = Object.keys(utms)
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(utms[k])}`)
    .join('&')
  const metaQuery = getMetaQuery({ ...metaParams, marketplace: verticals, type }, theme)
  const href = `${url}?${queryString}${metaQuery}`
  const formHref = `${formUrl}?${queryString}${metaQuery}`

  switch (variation) {
    case 'copy-only':
      return (
        <CopyOnly
          href={href}
          theme={theme}
          title={title}
          body={body}
          ctaText={ctaText}
          nmls={nmls}
        />
      )
    case 'interactive':
      return (
        <Interactive
          href={formHref}
          theme={theme}
          title={title}
          body={body}
          ctaText={ctaText}
          Form={form}
          queryString={queryString}
          metaQuery={metaQuery}
        />
      )
    default:
      return null
  }
}

RichCta.propTypes = {
  url: PropType.string.isRequired,
  formUrl: PropType.string,
  variation: PropType.string.isRequired,
  form: PropType.func,
  utms: PropType.object.isRequired,
  title: PropType.string.isRequired,
  theme: PropType.string.isRequired,
  body: PropType.string.isRequired,
  ctaText: PropType.string.isRequired,
  nmls: PropType.bool,
  metaParams: PropType.object,
  verticals: PropType.array,
  type: PropType.string,
}

RichCta.defaultProps = {
  nmls: false,
}

export { RichCta }

export default RichCta
